var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "hasDropdownChildren",
                          rawName: "v-hasDropdownChildren",
                        },
                      ],
                      on: { command: _vm.exportFiles },
                    },
                    [
                      _c("el-button", { attrs: { type: "primary" } }, [
                        _vm._v(" " + _vm._s(_vm.$t("exportText"))),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "outPutPdfFn" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessPurchaseEntryComPage.outPutPdfFn"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "outPutExcel" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessPurchaseEntryComPage.outPutExcel"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.data.purchaseType !== "COMMON"
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: "auOutPutPdfFn" } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "BusinessPurchaseEntryComPage.auOutPutPdfFn"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.pageType === "inform"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showLog },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "BusinessPurchaseEntryComView.operationLog"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("BusinessPurchaseEntryComView.purchase")) +
              _vm._s(_vm.$t("BusinessPurchaseEntryComView.informationText")) +
              " "
          ),
        ]
      ),
      _c("PdfTemplate", {
        ref: "pdfRef",
        attrs: { id: "pdfRef", data: _vm.data },
      }),
      _c("div", { staticClass: "bj-row mt20" }, [
        _c(
          "div",
          { staticClass: "bj-col-12", staticStyle: { "padding-left": "0" } },
          [
            [
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseEntryComPage.code"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.pageType === "inform"
                          ? _vm.data.code
                          : _vm.data.stockinCode
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseComponentsCom.purchaseCode"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.purchaseCode)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseComponentsPur.type"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(_vm.PURCHASE_TYPE.bjGet(_vm.data.purchaseType))
                    )
                  ),
                ]),
              ]),
            ],
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-form-item-label" }, [
                _vm._v(
                  _vm._s(_vm.$t("BusinessPurchaseEntryComView.supplierName"))
                ),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _vm._v(_vm._s(_vm.data.supplierName)),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-form-item-label" }, [
                _vm._v(_vm._s(_vm.$t("BjDialogListConfig.Suppliercode"))),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _vm._v(_vm._s(_vm.data.supplierCode)),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-form-item-label" }, [
                _vm._v(
                  _vm._s(_vm.$t("BusinessPurchaseComponentsCom.invoiceNo"))
                ),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _vm._v(_vm._s(_vm.data.invoiceNo)),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-form-item-label" }, [
                _vm._v(_vm._s(_vm.$t("table.creatorText"))),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _vm._v(_vm._s(_vm.data.createdName)),
              ]),
            ]),
          ],
          2
        ),
        _c("div", { staticClass: "bj-col-12" }, [
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(_vm._s(_vm.$t("table.createTimeText"))),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.creationDate)),
            ]),
          ]),
          _vm.pageType === "inform"
            ? _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseComponentsPur.postingDate"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.requiredDate)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseComponentsPur.documentDate"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.documentDate)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseComponentsCom.PO.loosDate"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.loosDate)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(_vm._s(_vm.$t("BusinessPurchaseEntryComPage.applyCode"))),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.applyCode)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseComponentsPur.vendorRefNo"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.vendorRefNo)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(_vm._s(_vm.$t("table.remarkText"))),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.remark)),
            ]),
          ]),
        ]),
      ]),
      _c("BjDivider", [
        _vm._v(
          " " + _vm._s(_vm.$t("BusinessPurchaseEntryComView.table.title")) + " "
        ),
      ]),
      [
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.data.goodsList,
              border: "",
              script: "",
              "max-height": "600px",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "contractNo",
                label: "合同号",
                align: "center",
                width: "175",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "skuCode",
                label: "SKU",
                align: "center",
                width: "180",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "planQty",
                label: "已出货数量",
                align: "center",
                width: "150",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "waitQty",
                label: "已装船数量",
                align: "center",
                width: "150",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "alreadyQty",
                label: _vm.$t("BusinessPurchaseEntryComPage.table.alreadyQty"),
                align: "center",
                width: "150",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "taxUnitPrice",
                label: _vm.$t("BusinessPurchaseComponentsPur.table.UnitPrice"),
                align: "center",
                width: "130",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "currency",
                label: _vm.$t("ChannelManagement.Header.currency"),
                align: "center",
                width: "130",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("BusinessPurchaseComponentsPur.table.Warehouse"),
                align: "center",
                width: "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.warehouseCode) + " ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "length",
                label: _vm.$t("BusinessPurchaseComponentsPur.table.Length"),
                align: "center",
                width: "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.length) + " cm ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "width",
                label: _vm.$t("BusinessPurchaseComponentsPur.table.Width"),
                align: "center",
                width: "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.width) + " cm ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "height",
                label: _vm.$t("BusinessPurchaseComponentsPur.table.Height"),
                align: "center",
                width: "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.height) + " cm ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "volume",
                label: _vm.$t("BusinessPurchaseComponentsPur.table.Volume"),
                align: "center",
                width: "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        " " + _vm._s(isNaN(row.volume) ? "" : row.volume) + " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "volumeUnit",
                  label: _vm.$t(
                    "BusinessPurchaseComponentsPur.table.VolumeUnit"
                  ),
                  align: "center",
                  width: "120",
                },
              },
              [_vm._v(" cm³ ")]
            ),
            _c("el-table-column", {
              attrs: {
                prop: "weight",
                label: _vm.$t("BusinessPurchaseComponentsPur.table.Weight"),
                align: "center",
                width: "130",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._v(" " + _vm._s(row.weight) + " kg ")]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      _vm.data.purchaseType !== "COMMON"
        ? [
            _c("BjDivider", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "BusinessPurchaseComponentsPur.table.FreightInformation"
                  )
                )
              ),
            ]),
            _c(
              "el-table",
              {
                attrs: {
                  border: "",
                  script: "",
                  "max-height": "600px",
                  data: _vm.freight,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "freightName",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsPur.table.FreightName"
                    ),
                    align: "center",
                    width: "130",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "taxGroup",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsPur.table.TaxGroup"
                    ),
                    align: "center",
                  },
                }),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "tax",
                      label: _vm.$t("BusinessPurchaseComponentsPur.table.Tax"),
                      align: "center",
                    },
                  },
                  [_vm._v(_vm._s(_vm.data.taxRate))]
                ),
                _c("el-table-column", {
                  attrs: {
                    prop: "netAmount",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsPur.table.NetAmount"
                    ),
                    align: "center",
                    width: "160",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "distribMethod",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsPur.table.DistribMethod"
                    ),
                    align: "center",
                  },
                }),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "totalTax",
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.table.TotalTaxAmount"
                      ),
                      align: "center",
                      width: "160",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.data.freightTax) + " ")]
                ),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    label: _vm.$t("table.statusText"),
                    align: "center",
                    width: "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "grossAmount",
                    label: _vm.$t(
                      "BusinessPurchaseComponentsPur.table.GrossAmount"
                    ),
                    align: "center",
                    width: "160",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }